module.exports = __webpack_public_path__ + "static/flatart-logo-d306e812ed728337e9294ed2bc93a47c.png";